const s = {
  name: "Cash",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<path class="st0" d="M20,19c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6S16.7,19,20,19z M20,9c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4
		S17.8,9,20,9z"/>
	<polygon class="st0" points="6,6 9,6 9,4 4,4 4,9 6,9 	"/>
	<polygon class="st0" points="9,20 6,20 6,17 4,17 4,22 9,22 	"/>
	<polygon class="st0" points="36,17 34,17 34,20 31,20 31,22 36,22 	"/>
	<polygon class="st0" points="34,9 36,9 36,4 31,4 31,6 34,6 	"/>
	<path class="st0" d="M0,0v26h40V0H0z M38,24H2V2h36V24z"/>
</g>
</svg>
  `
};
export {
  s as Cash
};
